const LinkedserviceAPI = {
  list: '/support_services',
  detail: '/support_services/:id',
  update: '/support_services/:id',
  create: '/support_services',
}
export const CAMPAIGN_API = {
  list: 'support_services/:id/campaigns',
  create: 'support_services/:id/campaigns',
  packages: 'support_services/packages',
}

export default LinkedserviceAPI
